var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDisclaimerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    fill: "#FDFBF2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.5526 24.1056C34.8341 24.6686 34.8341 25.3314 34.5526 25.8944L31.0526 32.8944C30.7138 33.572 30.0213 34 29.2637 34H20.7358C19.9783 34 19.2858 33.572 18.947 32.8944L15.447 25.8944C15.1655 25.3314 15.1655 24.6686 15.447 24.1056L18.947 17.1056C19.2858 16.428 19.9783 16 20.7358 16H29.2637C30.0213 16 30.7138 16.428 31.0526 17.1056L34.5526 24.1056Z",
    stroke: "#EFC819",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25 28.5H25.009",
    stroke: "#EFC819",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25 21.5V25.5",
    stroke: "#EFC819",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisclaimerIcon);
export default __webpack_public_path__ + "static/media/disclaimer-icon.de3c23414f537ccedd78986ac13a4830.svg";
export { ForwardRef as ReactComponent };